// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'bank-account.page.title': 'Bank Accounts',
    'bank-account.page.archive.title': 'Archived Bank Accounts',
    'bank-account.page.search_results': 'Search Results',
    'bank-account.page.create.title': 'Create New Bank Account',
    'bank-account.page.search.title': 'Find Bank Accounts',
    'bank-account.page.edit.title': 'Edit Bank Account',
    'bank-account.page.view.title': 'Bank Account',
    'bank-account.page.all': 'All',

    'bank-account.button.cancel': 'Cancel',
    'bank-account.button.select': 'Select',
    'bank-account.button.find': 'Find Bank Accounts',
    'bank-account.button.search': 'Apply',
    'bank-account.button.create': 'Save Bank Account',
    'bank-account.button.new': 'New Bank Account',
    'bank-account.button.save': 'Save Changes',
    'bank-account.button.archive': 'Archive Bank Account',
    'bank-account.button.delete': 'Permanently Delete',
    'bank-account.button.edit': 'Edit Bank Account',
    'bank-account.button.restore': 'Restore',
    'bank-account.button.reset': 'Reset',
    'bank-account.button.reconcile': 'Reconcile',

    'bank-account.placeholder.search': 'Search bank accounts',

    'bank-account.link.create_first_bank_account': 'Click here to create your first bank account',
    'bank-account.link.bank_accounts': ' Return to Bank Accounts',
    'bank-account.link.archive': 'Archived Bank Accounts',
    'bank-account.link.retry': 'Click here to retry',

    'bank-account.checkbox.all': 'Check All',
    'bank-account.checkbox.actions_label': 'with selected',

    'bank-account.label.bank_name': 'Bank',
    'bank-account.label.bank_account_type_name': 'Bank Account Type',
    'bank-account.label.general_ledger_account_name': 'General Ledger Account',
    'bank-account.label.account_name': 'Bank Account Name',
    'bank-account.label.bank_account_description': 'Bank Account Description',
    'bank-account.label.initial_date': 'Initial Date',
    'bank-account.label.currency_name': 'Currency',
    'bank-account.label.currency_initial_balance_in_cents': 'Initial Balance',
    'bank-account.label.base_initial_balance_in_cents': 'Base Initial Balance In Cents',
    'bank-account.label.system_initial_balance_in_cents': 'System Initial Balance In Cents',
    'bank-account.label.source_of_funds_general_ledger_account_name': 'Source Of Funds General Ledger Account',

    'bank-account.sort.field_label': 'Field',
    'bank-account.sort.direction_label': 'Direction',
    'bank-account.sort.direction_ascending': 'Ascending',
    'bank-account.sort.direction_descending': 'Descending',

    'bank-account.modal.title.bank_account_archive': 'Archive Bank Account',
    'bank-account.modal.title.bank_account_delete_permanently': 'Delete Bank Account',
    'bank-account.modal.title.bank_account_restore': 'Restore Bank Account',

    'bank-account.modal.message.bank_account_archive': 'Are you sure that you want to move this bank account to the archive? | Are you sure that you want to move these bank accounts to the archive?',
    'bank-account.modal.message.bank_account_delete_permanently':
        'Are you sure that you want to permanently delete this bank account? This action cannot be undone. | Are you sure that you want to permanently delete these bank accounts? This action cannot be undone.',
    'bank-account.modal.message.bank_account_restore': 'Are you sure that you want to restore this bank account? | Are you sure that you want to restore these bank accounts?',

    'bank-account.success.message.bank_account_created': 'Your bank account has been created',
    'bank-account.success.message.bank_account_updated': 'Your bank account has been updated',
    'bank-account.success.message.bank_account_restored': 'Your bank account has been restored | All selected bank accounts were restored',
    'bank-account.success.message.bank_account_deleted': 'Your bank account has been permanently deleted | All selected bank accounts were permanently deleted',
    'bank-account.success.message.archived_bank_accounts': 'Your bank account was moved to the archive | All selected bank accounts were moved to the archive',

    'bank-account.error.message.archived_bank_accounts': 'This bank account was already moved to the archive | These bank accounts were already moved to the archive',
    'bank-account.error.message.bank_account_deleted': 'This bank account was already permanently deleted | These bank accounts were already permanently deleted',
    'bank-account.error.message.bank_account_restored': 'This bank account was already restored | These bank accounts were already restored',
    'bank-account.error.message.error_loading_page': 'Sorry, there was an error loading bank account.| Sorry, there was an error loading bank accounts.',

    'bank-account.message.search.no_archived_bank_accounts': "You haven't archived any bank any accounts as yet.",

    'bank-account.button.link_bank': 'Link Bank',
    'bank-account.button.unlink_bank': 'Unlink Bank',
    'bank-account.button.relink_bank': 'Re-link Bank',

    'bank-account.aggregator.status.active': 'Connected',
    'bank-account.aggregator.status.pending_reauth': 'Re-authentication Required',
    'bank-account.aggregator.status.unlinked': 'Disconnected',
    'bank-account.aggregator.last_synced': 'Last synced',
    'bank-account.aggregator.never_synced': 'Never',

    'bank-account.dialog.link_bank.title': 'Link Bank Account',
    'bank-account.dialog.link_bank.description': 'Connect your bank account to automatically import transactions.',
    'bank-account.dialog.link_bank.loading': 'Loading bank connection...',
    'bank-account.dialog.link_bank.connecting': 'Connecting to bank...',

    'bank-account.dialog.unlink_bank.title': 'Unlink Bank Account',
    'bank-account.dialog.unlink_bank.message': 'Are you sure you want to disconnect this bank account? Transaction syncing will stop.',

    'bank-account.success.message.bank_linked': 'Your bank account has been linked successfully',
    'bank-account.success.message.bank_unlinked': 'Your bank account has been unlinked',
    'bank-account.error.message.bank_link_failed': 'Failed to link bank account. Please try again.',
    'bank-account.error.message.bank_unlink_failed': 'Failed to unlink bank account. Please try again.',
};
